module.exports = __webpack_public_path__ + "static/media/get-deposit.53d324ac.svg";